const OSS = require('ali-oss')
/** 历史阿里云连接配置
const OSSConfig = {
  uploadHost: 'https://qjprod-images.oss-cn-beijing.aliyuncs.com', // OSS上传地址
  type: 'scs',
  ossParams: {
    path: 'menuResource/', // 指定文件夹目录
    region: 'oss-cn-beijing', // 阿里云所在区域
    success_action_status: '200', // 上传成功的返回码，不设置默认返回204
    accessKeyId: 'LTAIuBMF9MOPd8um', // 阿里云的accessKeyId
    accessKeySecret: 'xfMahp9yACASmfcHrRGyLDvL3HX8T8', // 阿里云的accessKeySecret
    bucket: 'qjprod-images' // 阿里云的bucket
  }
}
*/

/** @name 上传图片到阿里云
 *  @param {File} file 文件内容
 *  @param {Object} ossConfig 阿里云配置
 *  - {String} uploadHost 阿里云文件预览地址
 *  - {String} region 阿里云所在区域
 *  - {String} bucket 阿里云的bucket
 *  - {String} fileDir 文件夹目录
 *  - {String} accessKeyId 阿里云的accessKeyId
 *  - {String} accessKeySecret 阿里云的accessKeySecret
 *  @return {String} 上传后的图片地址
 *  @version 2019-09-20
 */
export const upload = async function(file, ossConfig) {
  let  {region, bucket, fileDir, accessKeyId, accessKeySecret, uploadHost} = ossConfig;
  //  创建阿里云连接
  const client = new OSS({ region, bucket, accessKeyId, accessKeySecret });
  //  上传文件名称
  let uploadName = `${fileDir}/${file.uid}`;
  //  上传文件到服务器
  let result = await client.multipartUpload(uploadName, file);
  //  文件预览地址
  let previewPath = `${uploadHost}/${result.name}`;
  return previewPath;
}



// WEBPACK FOOTER //
// ./src/utils/upload.js